module.exports = __webpack_public_path__ + "img/dashboard.00931dd1.svg";